import React, { Component } from 'react'
import { Grid, Typography, GridProps, styled, TypographyProps, SxProps } from '@mui/material'
import { Theme } from '@emotion/react'

export interface IMediaInfoConfig<T> {
  key: keyof T
  label?: React.ReactNode
  /** Default: xs = 2 */
  size?: Pick<GridProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl'>
  valueFormatter?: (value: any, data?: T) => string | number
}

interface IOptions {}

function CreateMediaInfo<T>(configs: IMediaInfoConfig<T>[], options?: IOptions) {
  interface IProps {
    value?: T
    sx?: SxProps<Theme>
  }
  class MediaInfo extends Component<IProps> {
    render() {
      return (
        <Grid container spacing={1} sx={this.props.sx}>
          {configs.map((x, i) => {
            const value = this.getValue(x)
            return (
              <Grid item key={i} xs={2} {...x.size}>
                {this.renderLabel(x)}
                <Typography title={value.toString()} noWrap>
                  {value}
                </Typography>
              </Grid>
            )
          })}
        </Grid>
      )
    }

    renderLabel = (config: IMediaInfoConfig<T>) => {
      if (!config.label) return <TextLabel>{config.key.toString()}</TextLabel>
      if (typeof config.label === 'string' || typeof config.label === 'number') {
        return <TextLabel>{config.label.toString()}</TextLabel>
      }
      return config.label
    }

    getValue = (config: IMediaInfoConfig<T>) => {
      try {
        const value = this.props.value?.[config.key]
        if (config.valueFormatter) return config.valueFormatter(value, this.props.value)
        return value?.toString() ?? '...'
      } catch (error) {
        return '...'
      }
    }
  }
  return MediaInfo
}
export default CreateMediaInfo

const TextLabel = styled((p: TypographyProps) => <Typography variant='h6' {...p} />)({})
